import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/sections/Hero";
import { Stats } from "@/components/sections/Stats";
import { Services } from "@/components/sections/Services";
import { Approach } from "@/components/sections/Approach";
import { SafeMeSection } from "@/components/sections/SafeMeSection";
import { SecureDeskSection } from "@/components/sections/SecureDeskSection";
import { Trust } from "@/components/sections/Trust";
import { Partners } from "@/components/sections/Partners";
import { Contact } from "@/components/sections/Contact";
import { useAuth } from "@/context/AuthContext";

export default function Landing() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      };
      const t = setTimeout(scroll, 400);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  const handleBook = () => {
    if (user && user.role === "client") return navigate("/client");
    if (user && user.role === "partner") return navigate("/partner");
    navigate("/register?intent=book");
  };

  return (
    <div className="bg-black" data-testid="landing-page">
      <Seo
        title="Cybersecurity & Security Engineering | Aliwer"
        description="Aliwer helps organizations assess risk, secure systems, govern technology, and continuously prove their security posture."
        path="/"
      />
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        <Hero onBook={handleBook} />
        <Stats />
        <Services />
        <Approach />
        <SafeMeSection />
        <SecureDeskSection />
        <Trust />
        <Partners />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
